<template>
  <div class="session-expired">
    <img :src="getImage('error.svg')" alt="SE" />
    <h1>This session has expired</h1>
    <el-button type="primary" disabled>Reload</el-button>
  </div>
</template>

<script>
export default {
  name: "SessionExpired"
};
</script>

<style scoped lang="scss">
.session-expired {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    height: 220px;
    width: auto;
  }

  h1 {
    margin: 20px 0;
  }
}
</style>
